import {
  CameraMoveRequest,
  CameraOrientationEndpoints,
  CameraPanTiltRequest,
  CameraStopRequest,
  NavigateToPresetGroupRequest,
  NavigateToPresetRequest,
  PresetEndpoints,
  PresetGroupEndpoints,
  WinchEndpoints,
  WinchMove2DRequest,
  WinchMoveRequest,
  WinchStopRequest,
} from '@scaleaq/sitecontrol-lib';

import { API_NAMES } from '@/constants';
import { useAuthApiPost } from '@/dataAccess/rest/apiHooks';

export const useCameraRotationTiltUp = () => {
  return useAuthApiPost<CameraMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.tiltUp,
    returnJsonResult: false,
  });
};
export const useCameraRotationTiltDown = () => {
  return useAuthApiPost<CameraMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.tiltDown,
    returnJsonResult: false,
  });
};
export const useCameraRotationPanLeft = () => {
  return useAuthApiPost<CameraMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.panLeft,
    returnJsonResult: false,
  });
};
export const useCameraRotationPanRight = () => {
  return useAuthApiPost<CameraMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.panRight,
    returnJsonResult: false,
  });
};

export const useCameraPanTilt = () => {
  return useAuthApiPost<CameraPanTiltRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.panTilt,
    returnJsonResult: false,
  });
};

export const useCameraRotationStop = () => {
  return useAuthApiPost<CameraStopRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.stop,
    returnJsonResult: false,
  });
};

export const useCameraZoomIn = () => {
  return useAuthApiPost<CameraMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.zoomIn,
    returnJsonResult: false,
  });
};

export const useCameraZoomOut = () => {
  return useAuthApiPost<CameraMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: CameraOrientationEndpoints.zoomOut,
    returnJsonResult: false,
  });
};

export const useMoveWinchUp = () => {
  return useAuthApiPost<WinchMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: WinchEndpoints.moveWinchUp,
    returnJsonResult: false,
  });
};
export const useMoveWinchDown = () => {
  return useAuthApiPost<WinchMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: WinchEndpoints.moveWinchDown,
    returnJsonResult: false,
  });
};
export const useMoveWinchIn = () => {
  return useAuthApiPost<WinchMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: WinchEndpoints.moveWinchIn,
    returnJsonResult: false,
  });
};
export const useMoveWinchOut = () => {
  return useAuthApiPost<WinchMoveRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: WinchEndpoints.moveWinchOut,
    returnJsonResult: false,
  });
};

export const use2DWinchMovement = () => {
  return useAuthApiPost<WinchMove2DRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: WinchEndpoints.moveWinch,
    returnJsonResult: false,
  });
};

export const useMoveWinchStop = () => {
  return useAuthApiPost<WinchStopRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: WinchEndpoints.moveWinchStop,
    returnJsonResult: false,
  });
};

export const useNavigateToPreset = () => {
  return useAuthApiPost<NavigateToPresetRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: PresetEndpoints.navigateToPreset,
    returnJsonResult: false,
  });
};

export const useNavigateToPresetGroup = () => {
  return useAuthApiPost<NavigateToPresetGroupRequest>({
    baseApiRoute: API_NAMES.cameracontrolApi,
    cacheKeys: [],
    route: PresetGroupEndpoints.navigateToPresetGroup,
    returnJsonResult: false,
  });
};
